import { useContext, useEffect, useState } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { RequestEntity } from 'types';
import { getMediaFilePath } from 'backend/additionalInformation';

export const useEntityPhotoUrl = ({
	resource,
	entityId,
	filePath,
}: {
	resource: RequestEntity;
	entityId: string;
	filePath: Nullable<string>;
}) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const [photoUrl, setPhotoUrl] = useState<Nullable<string>>(null);
	const [isPhotoError, setIsPhotoError] = useState<boolean>(false);

	useEffect(() => {
		setPhotoUrl(null);
		setIsPhotoError(false);

		if (!entityId || !filePath) {
			return;
		}

		let isActual = true;

		const loadPhotoUrl = async () => {
			try {
				showLoader();
				const { data } = await getMediaFilePath({ resource, entityID: entityId, size: 'Medium' });
				if (isActual) {
					setPhotoUrl(data.preSignedUrl || null);
				}
			} catch {
				if (isActual) {
					setIsPhotoError(true);
				}
			} finally {
				hideLoader();
			}
		};

		loadPhotoUrl();

		return () => {
			isActual = false;
		};
	}, [resource, entityId, filePath]);

	return { photoUrl, isPhotoError };
};
